module.exports = __webpack_public_path__ + "img/doctor.6ef146a6.svg";